import { fetchConnectorsByAudience, fetchListConnectors } from '@/features/AudienceManager/data';
import { omnichatIndividualApproachStartDate } from '@/utilities/constants';
function isSameIntegration(a, b) {
    return (a.startDatetime === b.startDatetime &&
        a.enabled === b.enabled &&
        a.scheduleID === b.scheduleID &&
        a.interval === b.interval &&
        a.instance === b.instance);
}
const audienceManagerIntegrations = {
    namespaced: true,
    state: {
        isLoadingIntegrationsStage: false,
        integrationsOptions: [],
        integrationsToDeactive: [],
        audienceActiveConnectors: [],
        activeConnectorModal: {
            isVisible: false,
            connector: {},
            instanceId: undefined,
        },
        modal: {
            startTimeError: false,
        },
        showIntegrationSuccessModal: false,
        showIntegrationErrorModal: false,
        selectedConnectorsToSave: [],
        loadingPage: false,
        isOmnichatAndIndividualApproach: false,
    },
    getters: {
        getConnectorsToSave: state => state.selectedConnectorsToSave,
        isLoadingIntegrationsStage: state => state.isLoadingIntegrationsStage,
        integrationsOptions: state => state.integrationsOptions,
        integrationsToDeactive: state => state.integrationsToDeactive,
        activeConnectorModal: state => state.activeConnectorModal,
        showIntegrationSuccessModal: state => state.showIntegrationSuccessModal,
        showIntegrationErrorModal: state => state.showIntegrationErrorModal,
        audienceActiveConnectors: state => state.audienceActiveConnectors,
        getLoadingPage: state => state.loadingPage,
        isOmnichatAndIndividualApproach: state => state.isOmnichatAndIndividualApproach,
    },
    actions: {
        fetchListConnectors({ commit, dispatch, rootState, rootGetters }) {
            commit('SET_LOADING_INTEGRATIONS_STAGE', true);
            const audienceId = rootState.audienceManager.audienceId;
            const isViewMode = rootGetters['audienceManager/isView'];
            fetchListConnectors()
                .then(response => {
                commit('SET_LIST_CONNECTORS', response.data);
                if (isViewMode && audienceId) {
                    dispatch('fetchConnectorsByAudience', audienceId);
                }
            })
                .finally(() => {
                commit('SET_LOADING_INTEGRATIONS_STAGE', false);
            });
        },
        fetchConnectorsByAudience({ commit, dispatch }, audienceId) {
            fetchConnectorsByAudience(audienceId)
                .then(response => {
                if (response.data) {
                    commit('SET_AUDIENCE_ACTIVE_CONNECTORS', response.data);
                    response.data.forEach(integrationRow => {
                        dispatch('updateIntegration', integrationRow);
                    });
                }
            })
                .finally(() => {
                commit('SET_LOADING_INTEGRATIONS_STAGE', false);
            });
        },
        updateIntegration({ commit, getters }, integrationRow) {
            const integrationIndex = getters.integrationsOptions
                .map(connector => connector.alias)
                .indexOf(integrationRow.alias);
            const verifyIfIsOmnichatAndIndividualApproach = integrationRow.alias === 'omnichat' && integrationRow.startDatetime === omnichatIndividualApproachStartDate;
            if (verifyIfIsOmnichatAndIndividualApproach)
                commit('UPDATE_IS_OMNICHAT_AND_INDIVIDUAL_APPROACH', true);
            if (integrationIndex === -1)
                return;
            commit('UPDATE_INTEGRATION', { integrationIndex, integrationRow });
        },
        deactivateIntegration({ commit }, connectorItem) {
            const createPayload = {
                scheduleId: connectorItem.scheduleId,
                connectorId: connectorItem.id,
                interval: 0,
                enabled: 0,
            };
            commit('MARK_INTEGRATION_AS_PENDING_DEACTIVATION', createPayload);
        },
    },
    mutations: {
        SET_LOADING_INTEGRATIONS_STAGE(state, isLoading) {
            state.isLoadingIntegrationsStage = isLoading;
        },
        UPDATE_IS_OMNICHAT_AND_INDIVIDUAL_APPROACH(state, value) {
            state.isOmnichatAndIndividualApproach = value;
        },
        SET_LIST_CONNECTORS(state, connectors) {
            state.integrationsOptions = connectors;
        },
        ACTIVATE_INTEGRATIONS_SUCCESS_MODAL(state, isVisible) {
            state.showIntegrationSuccessModal = isVisible;
        },
        ACTIVATE_INTEGRATIONS_ERROR_MODAL(state, isVisible) {
            state.showIntegrationErrorModal = isVisible;
        },
        SET_AUDIENCE_ACTIVE_CONNECTORS(state, connectors) {
            state.audienceActiveConnectors = connectors;
        },
        TOGGLE_ACTIVATE_INTEGRATION_MODAL(state, payload) {
            state.activeConnectorModal.isVisible = payload?.isVisible ?? false;
            state.activeConnectorModal.connector = payload?.connector ?? {};
            state.activeConnectorModal.instanceId = payload?.instanceId ?? undefined;
        },
        MARK_INTEGRATION_AS_PENDING_DEACTIVATION(state, connectors) {
            state.integrationsToDeactive.push(connectors);
        },
        SET_LOADING_PAGE(state, value) {
            state.loadingPage = value;
        },
        UPDATE_VISIBILITY_INTEGRATION_MODAL(state, { type, value }) {
            state.modal[type] = value;
        },
        UPDATE_INTEGRATION(state, { integrationIndex, integrationRow }) {
            const currentIntegration = state.integrationsOptions[integrationIndex];
            Object.assign(currentIntegration, integrationRow);
            const wasPreviouslySaved = state.audienceActiveConnectors.some(existing => existing.alias === integrationRow.alias && isSameIntegration(existing, integrationRow));
            const isEditable = integrationRow.editable === true;
            const isNewOrModified = !wasPreviouslySaved;
            const alreadyInQueue = state.selectedConnectorsToSave.some(connector => connector.alias === integrationRow.alias);
            if (isNewOrModified && isEditable) {
                if (!alreadyInQueue) {
                    state.selectedConnectorsToSave.push(integrationRow);
                }
                else {
                    state.selectedConnectorsToSave = state.selectedConnectorsToSave.map(connector => connector.alias === integrationRow.alias ? integrationRow : connector);
                }
            }
            if (!isEditable) {
                state.selectedConnectorsToSave = state.selectedConnectorsToSave.filter(connector => connector.alias !== integrationRow.alias);
            }
        },
    },
};
export default audienceManagerIntegrations;
